import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";

export const emailContactMethods = graphql(/* GraphQL */ `
	fragment emailContactMethods on Contact {
		contactMethods {
			... on EmailContact {
				emailValue
			}
		}
		gid
		name
	}
`);

export const ListContacts = graphql(/* GraphQL */ `
	query ListContacts($params: ListContactsParams!) {
		listContacts(params: $params) {
			...emailContactMethods
		}
	}
`);

export const useListContacts = (gid?: GID) => {
	const { data, loading, error } = useQuery(ListContacts, {
		variables: {
			params: {
				contactGroupGID: gid as GID,
			},
		},
		skip: !gid,
	});

	const contacts =
		getFragmentData(emailContactMethods, data?.listContacts) ?? [];

	return {
		contacts,
		loading,
		error,
	};
};
